import type { DecorationPlugin } from '../types'

export const decorationPlugins: DecorationPlugin[] = []
